module.exports = __webpack_public_path__ + "img/fire.3c7ba795.png";